// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"61":"83837c0f","137":"65be3efc","173":"ea6116e0","207":"27800230","245":"cd4ce4c7","289":"9f1e1725","339":"389bd9fd","340":"39b37a9d","372":"cb30539d","462":"94839aab","597":"b8a0cadc","627":"c63debb7","813":"072edec8"}[chunkId] + ".chunk.js";
};